import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { loginClientUserAPI } from "../services/authService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "./styles.css";

function ClientSignin() {

    const { search } = useLocation();
    const p = new URLSearchParams(search);
    const primary = p.get("primary");
    const secondary = p.get("secondary");
    const bgHex = p.get("bg");
    const bgImageRaw = p.get("bg_image");
    const redirect_url=p.get("redirect_url");
    const state = p.get("state");
    const existedEmail = p.get("email");
    const incomingTitle = p.get("title");
    const faviconParam = p.get("favicon");
  
    // const redirect_url = new URLSearchParams(search).get("redirect_url") || "";
    const queryUrl = `redirect_url=${encodeURIComponent(redirect_url)}&primary=${encodeURIComponent(primary || "")}&secondary=${encodeURIComponent(secondary || "")}&bg=${encodeURIComponent(bgHex || "")}&bg_image=${encodeURIComponent(bgImageRaw || "")}&title=${encodeURIComponent(incomingTitle || "")}&favicon=${encodeURIComponent(faviconParam || "")}`;


  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [emailValidationErrors, setEmailValidationErrors] = useState("");
  const [passwordValidationErrors, setPasswordValidationErrors] = useState("");
  const [showPassword, setShowPassword] = useState(false); // 👁️ toggle state

  const checkLogin = () => {
    let code = localStorage.getItem("authfast");
    if (code) {
      window.location.href = `${redirect_url}?code=${code}&state=${encodeURIComponent(
        state
      )}`;
      return;
    } else if (existedEmail) {
      setEmail(existedEmail);
    }
  };

  useEffect(() => {
    checkLogin();
  }, []);

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setShowLoading(true);
      setErrorMessage("");
      setPasswordValidationErrors("");
      setEmailValidationErrors("");

      let res = await loginClientUserAPI(email, password, redirect_url);
      setShowLoading(false);
      let responseData = await res.json();

      if (res.status === 200 || res.status === 201) {
        localStorage.setItem("authfast", responseData.code);
        window.location.href = `${redirect_url}?code=${
          responseData.code
        }&state=${encodeURIComponent(state)}`;
      } else if (res.status === 401) {
        setErrorMessage(responseData.message);
      } else if (res.status === 422) {
        let emailError = responseData.errors.find(
          (error) => error.property === "email"
        );
        if (emailError) {
          let contaivalues = Object.values(emailError.constraints);
          setEmailValidationErrors(contaivalues[contaivalues.length - 1]);
        } else {
          setEmailValidationErrors("");
        }

        let passwordError = responseData.errors.find(
          (error) => error.property === "password"
        );
        if (passwordError) {
          let contaivalues = Object.values(passwordError.constraints);
          setPasswordValidationErrors(contaivalues[contaivalues.length - 1]);
        } else {
          setPasswordValidationErrors("");
        }
      }
    } catch (err) {
      console.log(err);
      setShowLoading(false);
    }
  };

  let validateForm = () => {
    if (!email || !password || showLoading) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <h2>Sign In</h2>

        {/* Email Field */}
        <div className="inputbox relative border-b-2 border-white field-input bg-transparent mb-4">
          <input
            type="text"
            placeholder="Email ID"
            className="input w-full max-w-sm bg-transparent focus:outline-none"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {emailValidationErrors && (
            <p className="text-[#ff3333] mb-2 space-x-4">
              {emailValidationErrors}
            </p>
          )}
        </div>

        {/* Password Field with Eye Icon 👁️ */}
        <div className="inputbox relative border-b-2 border-white bg-transparent mb-4">
          <div className="relative flex items-center">
            <input
              type={showPassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              required
              placeholder="Password"
              className="input w-full max-w-sm bg-transparent focus:outline-none pr-10"
            />
            <span
              className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-white hover:text-gray-300"
              onClick={() => setShowPassword((v) => !v)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setShowPassword((v) => !v);
                }
              }}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </span>
          </div>
          {passwordValidationErrors && (
            <p className="text-[#ff3333] mb-2 space-x-4">
              {passwordValidationErrors}
            </p>
          )}
        </div>

        {/* Error message */}
        {errorMessage && (
          <p className="text-[#ff3333] mb-2 space-x-4">{errorMessage}</p>
        )}

        {/* Forgot Password link */}
        <div className="w-full flex justify-end mt-2 mb-2">
          <Link
            to={`/forgot-password/client?${queryUrl}`}
            className="text-sm text-white hover:underline"
          >
            Forgot Password?
          </Link>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={validateForm()}
          className="w-full rounded-full py-2 font-semibold text-white duration-300 button-background"
        >
          {showLoading ? "Signing in..." : "Sign In"}
        </button>

        {/* Signup Link */}
        <div className="w-full flex justify-end mt-2 pb-5 pt-2">
          <span className="pl-10 text-white">
           Don't have an account? &nbsp;&nbsp;
            <Link
              className="link text-white hover:underline"
              to={`/signup/client?${queryUrl }`}
            >
              Sign Up
            </Link>
          </span>
        </div>
      </form>
    </>
  );
}

export default ClientSignin;
